import "./AboutStyles.css"

function AboutUs () {
    return(
        <div className="about-container">
            <h1>Our History</h1>
            <p>The origins of Trippy drawings go all the way back to the 1940s when Swiss chemist Albert Hofmann discovered lysergic acid diethylamide (LSD). Hofmann was researching derivates from lysergic acid to create a circulatory and respiratory stimulant that had no negative side effects on the uterus. The result? LSD. Once he created the drug, he started experimenting with it and soon discovered its psychedelic effects.</p>
            
            <h1>Our Mission</h1>
            <p>Our Mission is to touch the horrizon where our capabilities may succesfully meet with the requirements of our clients, that too with ultimate transparency and cost-effectivenes</p>

            <h1>Our Vision</h1>
            <p>To show the seeds of par-exxcellence serives with customes centric approach and reap the trust of worldwide clients</p>
        
        </div>

    )
}

export default AboutUs